import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Mail } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="bg-[#091F5C] text-[#D0E4FE]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12">

          {/* Brand */}
          <div className="lg:col-span-2 space-y-6">
            <div className="flex items-baseline space-x-2">
              <span className="text-[22px] tracking-[0.22em] font-heading font-bold text-white">
                FIND
              </span>
              <span className="text-[#7096D1] font-light">·</span>
              <span className="text-[22px] tracking-[0.22em] font-heading font-bold text-white">
                LET
              </span>
            </div>
            <p className="text-[#D0E4FE]/80 max-w-sm text-sm leading-relaxed font-light">
              A demand-driven London rental service. Renters define their brief once. Landlords submit inventory. Our concierge desk delivers curated matches, private viewings, and considered relocation.
            </p>
            <div className="pt-4 space-y-2 text-xs text-[#D0E4FE]/70">
              <p className="flex items-center space-x-2">
                <MapPin className="w-3.5 h-3.5" />
                <span>Mayfair & City of London</span>
              </p>
              <p className="flex items-center space-x-2">
                <Mail className="w-3.5 h-3.5" />
                <a href="mailto:concierge@findlet.uk" className="hover:text-white transition-colors" data-testid="footer-concierge-email">
                  concierge@findlet.uk
                </a>
              </p>
            </div>
          </div>

          {/* Renters */}
          <div className="space-y-4">
            <h4 className="text-white font-semibold text-[11px] uppercase tracking-[0.22em] font-heading">
              For Renters
            </h4>
            <ul className="space-y-3 text-sm font-light">
              <li><Link to="/find" data-testid="footer-link-find" className="hover:text-white transition-colors">Submit Search Brief</Link></li>
              <li><Link to="/tenant/dashboard" className="hover:text-white transition-colors">Tenant Portal</Link></li>
              <li><Link to="/move" className="hover:text-white transition-colors">FIND LET Move</Link></li>
              <li><Link to="/faqs" className="hover:text-white transition-colors">Renter FAQs</Link></li>
            </ul>
          </div>

          {/* Landlords */}
          <div className="space-y-4">
            <h4 className="text-white font-semibold text-[11px] uppercase tracking-[0.22em] font-heading">
              For Landlords
            </h4>
            <ul className="space-y-3 text-sm font-light">
              <li><Link to="/let" data-testid="footer-link-let" className="hover:text-white transition-colors">List Property</Link></li>
              <li><Link to="/landlord/dashboard" className="hover:text-white transition-colors">Landlord Dashboard</Link></li>
              <li><Link to="/partners" className="hover:text-white transition-colors">Agency Partners</Link></li>
              <li><Link to="/about" className="hover:text-white transition-colors">Service Tiers</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div className="space-y-4">
            <h4 className="text-white font-semibold text-[11px] uppercase tracking-[0.22em] font-heading">
              Company
            </h4>
            <ul className="space-y-3 text-sm font-light">
              <li><Link to="/about" className="hover:text-white transition-colors">About</Link></li>
              <li><Link to="/faqs" className="hover:text-white transition-colors">FAQs</Link></li>
              <li><Link to="/contact" data-testid="footer-link-contact" className="hover:text-white transition-colors">Contact</Link></li>
              <li><span className="text-[#D0E4FE]/70">Mon – Sat · 08:30–19:30 GMT</span></li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-[#334DAF]/40 flex flex-col sm:flex-row items-center justify-between text-xs text-[#D0E4FE]/60 gap-4 font-light">
          <p>© {new Date().getFullYear()} FIND LET. All rights reserved.</p>
          <div className="flex space-x-8">
            <Link to="/privacy" data-testid="footer-link-privacy" className="hover:text-white transition-colors">Privacy</Link>
            <Link to="/terms" data-testid="footer-link-terms" className="hover:text-white transition-colors">Terms</Link>
            <Link to="/aml" data-testid="footer-link-aml" className="hover:text-white transition-colors">AML</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
